import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import { Helper } from '../../../core/utils/Helper';
import { BaseServerData, IRestoreData, IStickyJump } from '../base/IData';
import { ReelGameData, WinGameData } from './GameDataModels';
import { BeheadedGameMode } from './BeheadedGameMode';

export class GameData {
    public raw: BaseServerData;

    public Win: WinGameData;
    public Reel: ReelGameData;

    private _stickyJumps: IStickyJump[] = [];

    public get totalCollectedSymbols(): number {
        return this.raw.totalCollectedSymbols;
    }

    public get previousTotalCollectedSymbols(): number {
        return this.raw.previousTotalCollectedSymbols;
    }

    public get numberOfFreespinsPlayed(): number {
        return this.raw.numberOfFreespinsPlayed;
    }

    public get numberOfDroppedScatter(): number {
        return this.raw.numberOfDroppedScatter;
    }

    public get wasFeatureBuy(): boolean {
        return this.raw.wasFeatureBuy;
    }

    public get positions(): boolean[][] {
        return this.raw.positions;
    }

    public get cutIndex(): number[] {
        return this.raw.cutIndex;
    }

    public get nextCollectedSouls(): number {
        return this.raw.nextCollectedSouls;
    }

    public get collectedSouls(): number {
        return this.raw.collectedSouls;
    }

    public get soulWildLevels(): number[] {
        return this.raw.soulWildLevels;
    }

    public get soulWildCollectedSouls(): number[] {
        return this.raw.soulWildCollectedSouls;
    }

    public get soulWildsLandedPositions(): { [key: string]: number[] } {
        return this.raw.soulWildsLandedPositions;
    }

    public get soulWildReel(): number[] {
        return this.raw.soulWildReel;
    }

    public get accumulatedRoundWin(): number {
        return this.raw.accumulatedRoundWin;
    }

    public get reelsAfterCollapse(): string[][] {
        return this.raw.reelsAfterCollapse;
    }

    public get reels(): string[][] {
        return this.raw.reels;
    }

    public get symbolSizes(): number[][] {
        return this.raw.symbolSizes;
    }

    public get evaluatedArea(): string[][] {
        return this.raw.evaluatedArea;
    }

    public get isRestoreState(): boolean {
        return this.raw.isRestoreState;
    }

    public get stickyJumps(): IStickyJump[] {
        return this._stickyJumps;
    }

    public get mode(): string {
        return this.raw.mode;
    }

    public get isAnAvalanche(): boolean {
        return this.mode.includes("AVALANCHE");
    }

    public get isNextAvalanche(): boolean {
        return this.nextMode.includes("AVALANCHE");
    }

    public get freespinsLeft(): number {
        return this.raw.freespinsLeft;
    }

    public get fsRestoreData(): IRestoreData {
        return Helper.fetchOrApply(this.raw.restoreData, {});
    }

    public get isNormalMode(): boolean {
        return this.raw.mode === GameMode.NORMAL;
    }

    public get isLastRound(): boolean {
        return this.raw.nextMode === GameMode.NORMAL;
    }

    public get isFreeSpin(): boolean {
        return this.raw.mode === GameMode.FREESPIN;
    }

    public get nextIsRespin(): boolean {
        return this.raw.nextMode === 'RESPIN';
    }

    public get nextMode(): string {
        return this.raw.nextMode;
    }

    public get lastSFSRound(): boolean {
        return this.raw.mode === BeheadedGameMode.SUPER_FREESPIN_END && this.raw.nextMode === BeheadedGameMode.NORMAL;
    }

    public get lastSFSEndRound(): boolean {
        return (
            (this.raw.mode === BeheadedGameMode.SUPER_FREESPIN ||
                this.raw.mode === BeheadedGameMode.SUPER_FREESPIN_AVALANCHE) &&
            this.raw.nextMode === BeheadedGameMode.SUPER_FREESPIN_END
        );
    }

    public get isNextFS(): boolean {
        return this.raw.mode !== BeheadedGameMode.FREESPIN && this.raw.nextMode === BeheadedGameMode.FREESPIN;
    }

    public get gameModeChanges(): boolean {
        return this.raw.mode !== this.raw.nextMode;
    }

    public get collectedSymbols(): number {
        return this.raw.collectedSymbols;
    }

    public get currentLevel(): number {
        return this.raw.currentLevel;
    }

    public get nextWinMultiplier(): number {
        return this.raw.nextWinMultiplier;
    }

    public get currentWinMultiplier(): number {
        return this.raw.winMultiplier;
    }

    public get nextLevel(): number {
        return this.raw.nextLevel;
    }

    public get willUpgrade(): boolean {
        return this.raw.currentLevel < this.raw.nextLevel;
    }

    constructor() {
        this.Reel = new ReelGameData();
        this.Win = new WinGameData();
    }

    public setData(data: BaseServerData): void {
        this.raw = data;

        this.Reel.apply(data);
        this.Win.apply(data);

        // this._stickyJumps = this.decryptStickyJumpPosition(data.stickyWildPositions);
    }
}
